import React from 'react'
import { ThemeColors } from 'src/shared/ui/consts-styles'

// eslint-disable-next-line react/prop-types
const Cross = ({ color = ThemeColors.getGrayColor(0.8) }) => {
    return (
        <svg
            id="Layer_1"
            version="1.1"
            viewBox="0 0 92 92"
            xmlns="http://www.w3.org/2000/svg"
            fill={color}
            x="0px"
            y="0px"
            xmlSpace="preserve">
            <path
                id="XMLID_732_"
                d="M70.7,64.3c1.8,1.8,1.8,4.6,0,6.4c-0.9,0.9-2,1.3-3.2,1.3c-1.2,0-2.3-0.4-3.2-1.3L46,52.4L27.7,70.7&#xA;&#x9;c-0.9,0.9-2,1.3-3.2,1.3s-2.3-0.4-3.2-1.3c-1.8-1.8-1.8-4.6,0-6.4L39.6,46L21.3,27.7c-1.8-1.8-1.8-4.6,0-6.4c1.8-1.8,4.6-1.8,6.4,0&#xA;&#x9;L46,39.6l18.3-18.3c1.8-1.8,4.6-1.8,6.4,0c1.8,1.8,1.8,4.6,0,6.4L52.4,46L70.7,64.3z"
            />
        </svg>
    )
}

export default Cross
